/**
 * Manages the main blog slideshow functionality with autoplay and hover controls.
 * Initializes Swiper slider with configurable options for each slideshow container.
 * @function
 */
(function () {
  /**
   * Initializes the slideshow functionality for each slideshow container
   * @function
   */
  const slideshow = () => {
    $(document).ready(function () {
      $('.js-slideshow-container').each(function () {
        const $this = $(this);
        const id = $this.attr('id');
        const sliderS = `#${id} .js-slideshow`;
        const paginationEl = `#${id} .swiper-pagination`;
        // ---
        let isHoverStopAutoplay = $this.data().isHoverStopAutoplay;
        const isAutoplay = $this.data().isAutoplay;
        const delaySlideing = $this.data().delaySlideing * 1000;
        const speedSlideing = $this.data().speedSlideing * 1000;
        isHoverStopAutoplay =
          isAutoplay === false ? false : isHoverStopAutoplay;

        /**
         * Returns autoplay configuration if enabled
         * @returns {Object} Autoplay configuration object
         */
        const insertAutoplay = () =>
          isAutoplay === true
            ? {
                autoplay: {
                  delay: delaySlideing,
                  disableOnInteraction: false,
                },
              }
            : {};

        const swiperSlideshow = new Swiper(sliderS, {
          parallax: true,
          speed: speedSlideing,
          loop: true,
          allowTouchMove: true,
          ...insertAutoplay(),
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          keyboard: false,
          watchSlidesProgress: true,
        });

        $(`${sliderS}`).mouseenter(function () {
          if (isHoverStopAutoplay === true) {
            stopSlide();
          }
        });

        $(`${sliderS}`).mouseleave(function () {
          if (isHoverStopAutoplay === true) {
            startSlide();
          }
        });

        /**
         * Starts the slideshow autoplay if enabled
         * @function
         */
        function startSlide() {
          if (isAutoplay === true) {
            swiperSlideshow.autoplay.start();
          }
        }

        /**
         * Stops the slideshow autoplay
         * @function
         */
        function stopSlide() {
          swiperSlideshow.autoplay.stop();
        }
      });
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    slideshow();
    document.addEventListener('shopify:section:load', function () {
      slideshow();
    });
  });
})();
